module.exports = __webpack_public_path__ + "static/TS-logo-footer-0d8a7a793b85178a9e92e589fa470ef0.png";